// NOTE - this also is defined in the API (must be kept in sync)
export const ESTATE_RESULT_ITEM_TYPE_PRICING: { [key: string]: number } = {
  NAME: 1,
  EMPLOYMENT: 1,
  ADDRESS: 1,
  PROPERTY: 1,
  COLLECTION: 1,
  TRADE: 1,
  ACCOUNT: 1,
};

export const UPLOAD_LIMIT_BYTES = 40 * 1024 * 1024;
export const UPLOAD_LIMIT_STRING = '40MB';
